// removed by extract-text-webpack-plugin
module.exports = {"title":"styles__title__2aNPP","bullet":"styles__bullet__3ntpq","description":"styles__description__jyNDX","includes":"styles__includes__cOLlE","image":"styles__image__36XDu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductDetails/styles.scss
// module id = 404
// module chunks = 0